export default __webpack_public_path__ + "static/media/footer-phone.c89c06d3.svg";